<template>
  <div>
      <div class="bg-gray-50 min-h-screen">
        <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-8">
            <h4 class="text-xl text-gray-800 font-bold mb-5">Edit Protest Request Evidence </h4>
            <div class="grid grid-cols-1 md:grid-cols-2 bg-white bg-opacity-80 border divide-y md:divide-y-0 md:divide-x">
                <div class="p-3">
                    <h4 class="font-medium text-gray-800 mb-2 -mt-1">Edit Evidence</h4>
                    <div class="shadow-sm bg-white p-1 border border-dashed border-gray-400 relative cursor-move">
                      <vue-cropper ref="cropper" :guides="true" :view-mode="2" drag-mode="move" :background="true"
                          :rotatable="true" :src="imgSrc" alt="Source Image" :aspectRatio="8/7"
                          ></vue-cropper>
                    </div>
                    <div class="text-right mt-3">
                        <button  @click="cropImage" v-if="imgSrc != ''" class="inline-flex items-center bg-indigo-50 border border-indigo-700 cursor-pointer hover:bg-gray-50 py-0.5 px-4 rounded-full text-indigo-700 text-sm font-medium focus:outline-none">
                            <svg class="h-4 w-4 mr-1" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.7 14.6501V7.3001H9.325V4.4501H16.7C17.4833 4.4501 18.15 4.7291 18.7 5.2871C19.25 5.84576 19.525 6.51676 19.525 7.3001V14.6501H16.7ZM16.7 23.4751V19.4751H7.325C6.54167 19.4751 5.875 19.2001 5.325 18.6501C4.775 18.1001 4.5 17.4334 4.5 16.6501V7.3001H0.5V4.4501H4.5V0.475098H7.325V16.6501H23.5V19.4751H19.525V23.4751H16.7Z" />
                            </svg>
                            Crop
                        </button>
    ​
                        <button @click="rotate" v-if="imgSrc != ''" class="inline-flex items-center bg-indigo-50 border border-indigo-700 cursor-pointer hover:bg-gray-50 py-0.5 px-4 rounded-full text-indigo-700 text-sm font-medium focus:outline-none ml-3">
                            <svg class="h-4 w-4 mr-1" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.8758 12.2H18.9758C18.8758 11.6333 18.7214 11.079 18.5128 10.537C18.3048 9.99567 18.0258 9.48333 17.6758 9L19.7508 7.05C20.3508 7.8 20.8384 8.61233 21.2138 9.487C21.5884 10.3623 21.8091 11.2667 21.8758 12.2ZM13.0508 23.025V20.15C13.6508 20.0667 14.2218 19.9207 14.7638 19.712C15.3051 19.504 15.8091 19.225 16.2758 18.875L18.2758 20.9C17.5258 21.5 16.7091 21.979 15.8258 22.337C14.9424 22.6957 14.0174 22.925 13.0508 23.025ZM19.7508 19.425L17.7008 17.425C18.0341 16.9583 18.3091 16.4543 18.5258 15.913C18.7424 15.371 18.8924 14.8167 18.9758 14.25H21.8758C21.8091 15.1667 21.5924 16.0583 21.2258 16.925C20.8591 17.7917 20.3674 18.625 19.7508 19.425ZM11.0508 23.025C8.50078 22.6917 6.38411 21.5957 4.70078 19.737C3.01745 17.879 2.17578 15.7 2.17578 13.2C2.17578 10.4667 3.10078 8.14567 4.95078 6.237C6.80078 4.329 9.05911 3.35833 11.7258 3.325L10.5508 2.15L12.5258 0.125L17.1508 4.75L12.5258 9.375L10.5508 7.35L11.7508 6.15C9.85078 6.2 8.25078 6.90833 6.95078 8.275C5.65078 9.64167 5.00078 11.2833 5.00078 13.2C5.00078 14.95 5.57178 16.4833 6.71378 17.8C7.85511 19.1167 9.30078 19.9 11.0508 20.15V23.025Z" />
                            </svg>
                            Rotate
                        </button>
                    </div>
                </div>
                <div class="px-4 py-3">
                    <h4 class="font-medium text-gray-800 mb-2 -mt-1">Preview Evidence</h4>
                    <div>
                        <img class="block" v-if="isCropeedImageSelect" :src="cropImg">
                    </div>
                </div>
            </div>


              <div class="mt-6">
                <label for="comment" class="block text-sm font-medium text-gray-700">Reason To Edit</label>
                <div class="mt-1">
                  <textarea maxlength="500" v-model="comment" rows="4" name="comment" id="comment" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
                </div>
              </div>
              <div class="text-center mt-4">
                <button @click="backToAdminSide" type="button" class="inline-flex items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Back</button>
                <button @click="saveImage" type="button" class="inline-flex items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Save</button>
              </div>

        </div>
    </div>

  </div>

</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { siteUrl } from '../../config/base';
import ProtestRequestApi from "../../services/api/AdminProtestRequest";
export default {
props :["evidence_data","protest_request_uid"],
   components: {
     VueCropper
   },
  data() {
    return {
      cropImg: "",
      isCropeedImageSelect:false,
      comment:'',
    };
  },
  created(){
      this.imgSrc = siteUrl+'/storage/'+this.evidence_data['file_path'];
  },
  methods: {
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL("image/png");
      this.isCropeedImageSelect = true;
      this.comment = '';
    },
    rotate() {
      this.$refs.cropper.rotate(90);
    },
    saveImage(){
       if(this.cropImg == ''){
            this.$toast.error('Please edit the evidence');
            return ;
       }
      if(this.comment == '' ){
            this.$toast.error('Please enter the message');
            return ;
      }
      if(this.comment.length > 500) {
        this.$toast.open('Maximum character allowed in comment is 500');
        return;
      }


      let formData = new FormData();
      var file_evidence_data = this.dataURLtoFile(this.cropImg,'image.png');
      formData.append('file',file_evidence_data);
      formData.append('protest_request_evidence_id',this.evidence_data['protest_request_evidence_id']);
      formData.append('protest_request_evidence_uid',this.evidence_data['uid']);
      formData.append('comment',this.comment);
      ProtestRequestApi.saveEvidence(
      formData
    ).then((res) => {
      this.$toast.open('Evidence Update');
      window.location.href = siteUrl+'/admin/protest-requests/'+this.protest_request_uid+'/evidences/show';
    }).catch(function(error) {
      throw new Error(error);
    });

    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {type:mime});
    },
    backToAdminSide(){
      window.location.href =
          siteUrl + "/admin/protest-requests/"+this.protest_request_uid+"/evidences/show";
    }
  }
};
</script>

<style scoped>
</style>
